import type { InternalAxiosRequestConfig } from 'axios';
import axios from 'axios';

import { e2eTestsSkipToken } from '@/constants/env';
import settings from '@/data/constants';
import { getToken, logout } from '@/data/service/authService';

const isPmsURL = (config: InternalAxiosRequestConfig) => axios.getUri(config).startsWith(settings.url.toLowerCase());

const bearerTokenInjector = (config: InternalAxiosRequestConfig) => {
  if (isPmsURL(config)) {
    const token = getToken();
    if (token) {
      config.headers.setAuthorization(`Bearer ${token}`);
    }
  }

  return config;
};

const logoutOnInvalidToken = (error: unknown) => {
  if (axios.isAxiosError(error) && error.config && isPmsURL(error.config)) {
    const HTTP_UNAUTHORIZED = 401;
    const status = error.response?.status;
    const overrideJWTToken = e2eTestsSkipToken() === 'true';
    if (status === HTTP_UNAUTHORIZED && !overrideJWTToken) {
      logout();
    }
  }

  throw error;
};

axios.interceptors.request.use(bearerTokenInjector);
axios.interceptors.response.use(undefined, logoutOnInvalidToken);
